function formatPercent(value) {
    return Math.round(value * 100) + '\xa0%';
}
function convertLineBreaksToHTML(str) {
    return str.replace(/\r\n/g, '<br>');
}
export const Formatter = {
    formatPercent,
    convertLineBreaksToHTML,
};
